// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversazione',
  working: 'Ci sto lavorando…',
  stopped: 'Interrotto. Nulla è cambiato.',
  step_stopped: 'Interrotto',
  not_sent: 'Non inviato',
  failed: {
    text: 'Qualcosa è andato storto da parte mia, quindi nulla è cambiato. Riprova tra un momento.',
    retry: 'Riprova',
  },
  question: {
    type_answer: 'Oppure scrivi la tua risposta qui sotto.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo non è disponibile al momento.',
      assistant: "L'assistente non è disponibile al momento.",
    },
    text: 'Nulla è cambiato e il resto della dashboard funziona normalmente. Riprova tra qualche minuto.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Oggi',
  when: {
    today: 'Oggi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line: 'Nuova chat per {{restaurant}}. Le chat di {{previous}} si trovano in Chat quando ci torni.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat di {{name}} (FoodAmigos)',
      owner: 'Chat di {{name}} (titolare)',
      staff: 'Chat di {{name}} (staff)',
      partner: 'Chat di {{name}} (partner)',
      other: 'Chat di {{name}}',
      unnamed: 'Chat di un altro utente',
    },
    text: 'Chat di {{name}}. Puoi leggerla, ma non rispondere né approvare le sue schede.',
    text_unnamed: 'Chat di un altro utente. Puoi leggerla, ma non rispondere né approvare le sue card.',
    new_chat: 'Nuova chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Questa chat è terminata. Avvia una nuova chat per continuare.',
    new_chat: 'Nuova chat',
    moved_line: 'Nuova chat, perché la precedente era terminata',
  },
  composer: {
    label: 'Messaggio',
    placeholder: 'Fai una domanda o descrivi una modifica',
    placeholder_answer: 'Digita la tua risposta',
    hint: 'Invio per inviare · Maiusc+Invio per andare a capo',
  },
  table: {
    show_all: 'Mostra tutte le {{count}} righe',
    show_fewer: 'Mostra meno',
  },
  steps: {
    areas: 'Verifico in cosa posso aiutarti qui',
    area_describe: 'Sto esaminando {{area}}',
    read: 'Sto leggendo i tuoi dati',
    propose: 'Sto preparando la modifica',
    change_set_get: 'Sto controllando la modifica',
    gap_record: 'Lo annoto per il nostro team',
    research: 'Sto cercando come funziona',
    screen_find: 'Sto cercando la pagina giusta',
    file_read: 'Sto leggendo il tuo file',
    shop_check: 'Sto controllando il tuo shop',
    area_describe_other: "Sto guardando quest'area",
    other: 'Sto controllando qualcosa',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Impossibile leggere il menu',
      hours: 'Impossibile leggere gli orari di apertura',
      order_settings: 'Impossibile leggere le impostazioni degli ordini',
      my_info: 'Impossibile leggere i tuoi dati',
      marketing: 'Impossibile leggere il tuo marketing',
      gift_cards: 'Impossibile leggere le carte regalo',
      reports: 'Impossibile leggere i tuoi numeri',
      other: 'Impossibile leggere i tuoi dati',
    },
    propose: {
      menu: 'Impossibile preparare la modifica del menu',
      hours: 'Impossibile preparare la modifica degli orari di apertura',
      order_settings: 'Impossibile preparare la modifica delle impostazioni degli ordini',
      my_info: 'Impossibile preparare la modifica dei tuoi dati',
      marketing: 'Impossibile preparare la modifica del marketing',
      gift_cards: 'Impossibile preparare la modifica delle carte regalo',
      other: 'Impossibile preparare la modifica',
    },
    change_set_get: { other: 'Impossibile verificare la modifica' },
    research: { other: 'Impossibile cercare come funziona' },
    screen_find: { other: 'Impossibile trovare la pagina' },
    file_read: { other: 'Impossibile leggere il tuo file' },
    shop_check: { other: 'Impossibile aprire il tuo negozio' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'il menu',
    hours: 'gli orari di apertura',
    order_settings: 'le impostazioni degli ordini',
    my_info: 'le info del tuo ristorante',
    marketing: 'il marketing',
    reports: 'i report',
  },
};
